<div *ngIf="imageData && showImage" class="product-list-header">
  <div class="image" [ngStyle]="{ 'background-image': 'url(\'' + imageData.image + '\')' }">
    <p class="product-list-header-title" *ngIf="imageData.title">
      {{ translateService.instant(imageData.title) }}
    </p>
  </div>
</div>
